import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

/** Ensures new password is not identical to the current password field. */
export function NewPasswordNotSameAsCurrentValidator(
  currentPasswordControlName: string,
  newPasswordControlName: string
): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const group = formGroup as FormGroup;
    const currentControl = group.controls[currentPasswordControlName];
    const newControl = group.controls[newPasswordControlName];

    if (!currentControl || !newControl) {
      return null;
    }

    const currentValue = currentControl.value;
    const newValue = newControl.value;

    if (newValue && currentValue && newValue === currentValue) {
      const existingErrors = newControl.errors ?? {};
      newControl.setErrors({ ...existingErrors, sameAsCurrentPassword: true });
    } else if (newControl.errors?.['sameAsCurrentPassword']) {
      const { sameAsCurrentPassword, ...remainingErrors } = newControl.errors;
      newControl.setErrors(Object.keys(remainingErrors).length ? remainingErrors : null);
    }

    return null;
  };
}
